import './style.scss';

import { AnimatePresence } from 'framer-motion';
import { StateMachineProvider } from 'little-state-machine';
import { Outlet } from 'react-router-dom';

import { AnimateTextTyping, Expand, ProgressBar } from '@/components';

import { Content } from '../content';

interface ILander15 {
	percent: number;
	message: string;
	done: boolean;
	setDone: (done: boolean) => void;
	handleNext: () => void;
	versionId: string;
	landerId: string;
}

export const Lander15 = ({
	percent,
	message,
	done,
	setDone,
	handleNext,
	landerId,
	versionId,
}: ILander15) => {
	const lander = Content[landerId][versionId]?.lander;

	return (
		<StateMachineProvider>
			<div className={`lander15__wrapper lander15__wrapper--v${versionId}`}>
				<img
					className={`lander15__wrapper__background--image`}
					src={lander?.bgImage}
					alt="background"
				/>
				<div className={`lander15__wrapper__container`}>
					<ProgressBar
						percent={percent}
						baseColor={lander?.progressBarBaseColor}
						progressColor={lander?.progressBarProgressColor}
						hidePercentage={lander?.hidePercentage}
						barWidth={lander?.progressBarWidth}
					/>
					<div
						className={`lander15__wrapper__container__content lander15__wrapper__container__content--v${versionId}`}
					>
						<div className={`lander15__wrapper__container__content__host`}>
							<div
								className={`lander15__wrapper__container__content__host--image lander15__wrapper__container__content__host--image--v${versionId}`}
							>
								<img
									src={lander?.hostImage}
									alt="host"
									className={`lander15__wrapper__container__content__host--image--avatar`}
								/>
							</div>
							<div
								className={`lander15__wrapper__container__content__host--bubble lander15__wrapper__container__content__host--bubble--v${versionId}`}
							>
								<AnimatePresence mode="wait">
									{message && (
										<AnimateTextTyping
											key={message}
											text={message}
											setDone={setDone}
											cursorBlinkerColor="#fff"
										/>
									)}
								</AnimatePresence>
							</div>
						</div>
						<div
							className={`lander15__wrapper__container__content--expandWrapper`}
						>
							<Expand expanded={done} key={message}>
								<Outlet context={{ handleNext, landerId, versionId }} />
							</Expand>
						</div>
					</div>
				</div>
			</div>
		</StateMachineProvider>
	);
};
